<template>
  <div class="diLink">
    <!--
      <infoChangeDetail
      v-if="type == 'detail'"
      :detail="detail"
      @showList="showList"
    ></infoChangeDetail>
    -->
    <infoChange
      v-if="type == 'detail' || type == 'change'"
      :type="type"
      :detail="detail"
      @showList="showList"
      :change-type="changeType"
    ></infoChange>
    <div v-if="type == 'list'" class="diLinkTable prow20">
      <div class="table-top">
        <div>
          <Rectangle name="查询结果" />
          <TipsLabel
            tip="总条数统计："
            :count="pageObj.total"
            :countColor="'#1B5BBF'"
          />
        </div>
        <iconBtn
          v-if="this.isAdmin"
          @btnClick="selectChangeType"
          :name="'信息变更'"
          :path="
            require('@/assets/img/operationCenter/other/icon_modify@2x.png')
          "
          class="add-btn"
        />
      </div>
      <Table
        :show-pagination="true"
        :page="pageObj"
        @setcurrentpage="setCurPage"
        :tableProp="tableProp"
        :tableData="tableData"
        :ishandle="true"
        :isOrderNo="true"
        :isSection="false"
        :operateArray="operateArray"
        :operateWidth="190"
      >
        <template v-if="isAdmin" slot="edit" slot-scope="scope">
          <span @click="toDetail(scope.index, scope.row)" class="oper"
            >详情</span
          >
          <span
            v-if="
              scope.row.workflowStatus == '0' || scope.row.workflowStatus == '3'
            "
            @click="toEdit(scope.index, scope.row)"
            class="oper"
            >{{ scope.row.workflowStatus == "3" ? "退回修改" : "修改" }}</span
          >
          <span
            v-if="scope.row.workflowStatus == '3'"
            class="oper"
            @click="toStopApply(scope.row)"
          >
          终止申请
          </span>
          <span
            v-if="scope.row.workflowStatus == '0'"
            class="oper"
            @click="toDelete(scope.row)"
          >
          删除
          </span>
          <!--
          <el-popconfirm
            v-if="scope.row.workflowStatus == '0'"
            icon="el-icon-info"
            icon-color="red"
            class="delete-confirm"
            @confirm="toDelete(scope.row)"
            title="确定删除该申请码?"
          >
            <span slot="reference" class="oper">删除</span>
          </el-popconfirm>
          -->
        </template>
      </Table>
    </div>

    <el-dialog title="请选择变更类型"  :width="currentCompanyRole == 'member' ? '500px': '400px'" :visible.sync="beforeChangeInfo">
      <el-radio v-model="changeType" label="1">变更信息</el-radio>
      <el-radio v-model="changeType" label="2">变更营业执照</el-radio>
      <el-radio v-if="currentCompanyRole == 'member'" v-model="changeType" label="3">上传签发协议授权流程材料</el-radio>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" class="fsp-btn-blue-bg" @click="changeInfo()"
          >确 定</el-button
        >
        <el-button class="back-button" @click="beforeChangeInfo = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getComInfoChangeList,
  getComInfoChangeDetail,
  getCurrentComInfo,
  removeComInfoChange,
  terminateComInfoChange
} from "@/http/usercenter.js";
import InfoChangeDetail from "./InfoChangDetail";
import InfoChange from "./InfoChange";
import { companyWorkflowStatus } from "@/views/userManagement/userdatadictionary.js";
import _ from "lodash";
import { Loading } from "element-ui";
const CHANGE_TYPE_LIST =["1","2","3"];
export default {
  name: "InfoChangeList",
  components: { InfoChangeDetail, InfoChange },
  data() {
    return {
      isAdmin: false,
      beforeChangeInfo: false,
      changeType: "1",
      currentCompanyRole: '',
      tableProp: [
        {
          code: "createTimeStr",
          label: "申请日期",
          minWidth: 150,
        },
        {
          code: "updateTimeStr",
          label: "审核日期",
          minWidth: 150,
        },
        {
          code: "adminName",
          label: "管理员姓名",
          minWidth: 180,
        },
        {
          code: "phoneNo",
          label: "联系方式",
          minWidth: 150,
        },
        {
          code: "workflowStatusName",
          label: "审核状态",
          minWidth: 120,
          // formatter:this.formatter
        },
        {
          code: "notes",
          label: "拒绝原因",
          minWidth: 200,
        }, //只有拒绝的时候才会返回
      ],
      tableData: [],
      operateArray: ["edit"],
      pageObj: {
        total: 0,
        currentPage: 1,
        size: 10,
      },
      detail: {},
      type: "list", // detail change list
    };
  },
  mounted() {
    //console.log('mounted');
    // 判断非管理员不显示变更按钮
    const roleCode = this.$store.state.user.currentCompany.roleCode;
    this.isAdmin = roleCode && this.endWith(roleCode, "001");
    //console.log('roleCode:', roleCode, 'isAdmin', this.isAdmin);
  },
  methods: {
    endWith(str, end) {
      const d = str.length - end.length;
      return d >= 0 && str.lastIndexOf(end) == d;
    },
    setCurPage(val) {
      this.pageObj.currentPage = val;
      this.getInfoChangeList();
    },
    selectChangeType() {
      const currentCompany = JSON.parse(sessionStorage.getItem("company"));
      if(currentCompany && currentCompany.companyRole) {
        this.currentCompanyRole = currentCompany.companyRole;
      }
      this.beforeChangeInfo = true;
    },
    async changeInfo() {
      this.beforeChangeInfo = false;
      const req = {
        userNo: JSON.parse(sessionStorage.getItem("currentUser")).userNo,
        companyNo: JSON.parse(sessionStorage.getItem("company")).companyNo,
      };
      const resp = await getCurrentComInfo(req);
      if (resp.ret === 0) {
        this.detail = resp.data;
        //this.detail.origin.userInfo.phoneNo = this.detail.origin.companyInfo.organizerPhone;
        this.type = "change";
      }
    },
    showList() {
      this.type = "list";
      this.getInfoChangeList();
    },
    checkAuthFiles() {},
    hideChange() {
      this.isShowChange = false;
    },
    toDelete(row) {
      // debugger
      let _this = this;
      const req = {
        authApplyNo: row.authApplyNo,
        companyNo: row.companyNo,
      };
      this.$DLMessageBox({
        type: "warn",
          title: "删除提醒",
          content: "确定删除该申请吗?",
          confirmButtonText: "确定",
          showCancelButton: true,
          callback: (action) => {
            // confirm   确定   cancel   取消
            if (action == "confirm") {
              removeComInfoChange(req).then((resp) => {
                if (resp.ret == 0) {
                  _this.$message.success("删除成功");
                  _this.getInfoChangeList();
                } else {
                        _this.$message.error("删除失败");
                      }
              }).catch((ex) => {
                      _this.$message.error("删除异常");
                });
            }
        },
      });
    },
    toStopApply(row) {
      let _this = this;
      const req = {
        authApplyNo: row.authApplyNo,
        companyNo: row.companyNo,
      };
      this.$DLMessageBox({
        type: "warn",
          title: "终止申请提醒",
          content: "确定终止该申请吗?",
          confirmButtonText: "确定",
          showCancelButton: true,
          callback: (action) => {
            // confirm   确定   cancel   取消
            if (action == "confirm") {
              terminateComInfoChange(req).then((resp) => {
                if (resp.ret == 0) {
                  _this.$message.success("终止成功");
                  _this.getInfoChangeList();
                } else {
                        _this.$message.error("终止失败，请稍后再试");
                      }
              }).catch((ex) => {
                      _this.$message.error("终止异常，请稍后再试");
                });
            }
        },
      });
    },
    // 查看详情
    syncAuthFileData(detailData) {
      //debugger
      const changeTo = detailData.changeto;
      const origin = detailData.origin;
      changeTo.authFiles = Object.assign({}, changeTo.userInfo.userAuthFiles, changeTo.companyInfo.companyAuthFiles);
      origin.authFiles = Object.assign({}, origin.userInfo.userAuthFiles, origin.companyInfo.companyAuthFiles);
    },
    async toDetail(index, item) {
      this.changeType = "1";
      const resp = await getComInfoChangeDetail({
        authApplyNo: item.authApplyNo,
      });
      if (resp.ret === 0) {
        //debugger
        this.detail = resp.data;

        this.syncAuthFileData(this.detail);
        //this.detail.origin.userInfo.phoneNo = this.detail.origin.companyInfo.organizerPhone;
        this.checkChangeType();
        this.type = "detail";
      }
      //console.log("this.detail", this.detail);
    },
    async toEdit(index, item) {
      this.changeType = "1";
      const resp = await getComInfoChangeDetail({
        authApplyNo: item.authApplyNo,
      });
      if (resp.ret === 0) {
        this.type = "change";
        this.detail = resp.data;
        this.syncAuthFileData(this.detail, resp.data);
        //this.detail.origin.userInfo.phoneNo = this.detail.origin.companyInfo.organizerPhone;
        this.checkChangeType();
      }
      console.log("this.detail", this.detail);
    },
    // 信息变更列表
    async getInfoChangeList() {
      // debugger
      const company = JSON.parse(sessionStorage.getItem("company") || "{}");
      const reqData = {
        filterData: {
          // "companyName": company.companyName,      // 公司名称
          // "creditCode": "123456",     // 信用代码
          // "companyRole": "supply"     // 平台角色：finance-资金方 supply-供应商 member-成员企业 core-核心企业
        },
        pageData: {
          page: this.pageObj.currentPage,
          pageSize: this.pageObj.size, // todo 分页之后需要调整
        },
      };
      const resp = await getComInfoChangeList(reqData);
      if (resp.ret == 0) {
        this.pageObj.total = resp.data.totalElements;
        this.tableData = resp.data.content;
        for (let item of this.tableData) {
          item.workflowStatusName =
            companyWorkflowStatus.get(item.workflowStatus) ||
            item.workflowStatus;
          //只显示拒绝的原因
          if (item.workflowStatus != "3") {
            item.notes = "";
            item.remark = "";
          }
        }
      }
    },

    checkChangeType() {
      const changeToIssueAgreement = _.get(this.detail, "changeto.companyInfo.companyAuthFiles.issueAgreement");
      if(changeToIssueAgreement) {
        const originIssueAgreement = _.get(this.detail, "origin.companyInfo.companyAuthFiles.issueAgreement");
        if(changeToIssueAgreement != originIssueAgreement) {
          this.changeType = "3";
          return ; 
        }
      }
      const changeToBusinessLicenceId = _.get(this.detail, "changeto.companyInfo.companyAuthFiles.businessLicenceId");
      if(changeToBusinessLicenceId) {
        const originBusinessLicenceId = _.get(this.detail, "origin.companyInfo.companyAuthFiles.businessLicenceId");
        if(originBusinessLicenceId != changeToBusinessLicenceId) {
          this.detail.origin.companyInfo.companyAuthFiles.businessLicenceId = changeToBusinessLicenceId;

          const originCompanyInfo = this.detail.origin.companyInfo;
          const originUserInfo = this.detail.origin.userInfo;
          const changeToCompanyInfo = this.detail.changeto.companyInfo;
          const changeToUserInfo = this.detail.changeto.userInfo;
          const originIsOrganizer = originUserInfo.isOrganizer;
          delete originUserInfo.isOrganizer;
          /*
          console.log("origin.companyInfo", originCompanyInfo);
          console.log("changeto.companyInfo", changeToCompanyInfo);
          console.log("origin.userInfo", originUserInfo);
          console.log("changeto.userInfo", changeToUserInfo);
          console.log("userInfo compare", _.isEqual(originUserInfo, changeToUserInfo));
          console.log("companyInfo compare", _.isEqual(originCompanyInfo, changeToCompanyInfo));
          */
          if(_.isEqual(originCompanyInfo, changeToCompanyInfo) && _.isEqual(originUserInfo, changeToUserInfo)) {
            this.changeType ="2";
          }
          //还原数据
          this.detail.origin.companyInfo.companyAuthFiles.businessLicenceId = originBusinessLicenceId;
          originUserInfo.isOrganizer = originIsOrganizer;
          return ;
        }
      }
    }
  },
  async created() {
    //debugger
    let loadingInstance = Loading.service({
              lock: true,
              text: 'Loading',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
    });
    if (this.$route.query.business_id) {
      this.changeType = "1";
      const businessId = this.$route.query.business_id;

      const resp = await getComInfoChangeDetail({ businessId });
      if (resp.ret === 0) {
        this.detail = resp.data;
        this.syncAuthFileData(this.detail, resp.data);
        if (this.$route.query.type == "view") {
          this.type = "detail";
        } else {
          this.type = "change";
        }
      } else {
        this.$message.error("数据获取失败");
      }
      this.checkChangeType();
      loadingInstance.close();
      return ;
    }

    if(this.$route.query.changeType && CHANGE_TYPE_LIST.includes(this.$route.query.changeType)) {
      this.changeType = this.$route.query.changeType;
      const req = {
        userNo: JSON.parse(sessionStorage.getItem("currentUser")).userNo,
        companyNo: JSON.parse(sessionStorage.getItem("company")).companyNo,
      };
      getCurrentComInfo(req).then((res) => {
        if (res.ret === 0) {
          this.detail = res.data;
          //this.syncAuthFileData(this.detail, res.data);
          this.type = "change";
          //this.checkChangeType();
        } else {
          this.$message.error("数据获取失败");
        }
      });
      loadingInstance.close();
      return ;
    }
      
    this.getInfoChangeList();
    loadingInstance.close();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="less" scoped>
/deep/ .oper {
  color: #1b5bbf;
  padding-right: 10px;
  cursor: pointer;
}

.tc {
  text-align: center;
}
/deep/ .mr10 {
  margin-right: 10px;
}
.mt50 {
  margin-top: 50px;
}
.confirm-text {
  font-size: 16px;
  text-align: center;
}
.confirm-dialog {
  .el-dialog {
    width: 300px;
  }
}
.fsp-btn-blue-bg {
  background-color: #1b5bbf;
  margin-right: 10px;
}

/deep/ .el-dialog {
  border-radius: 12px;
  width: 400px;
  .el-dialog__header {
    position: relative;
    padding: 9px 17px 10px;
    background: #edf1f7;
    border-radius: 6px 6px 0px 0px;
    height: 40px;
    box-sizing: border-box;
  }
  .el-radio__input.is-checked .el-radio__inner {
    border-color: #1b5bbf;
    background: #1b5bbf;
  }
  .el-radio__input.is-checked + .el-radio__label {
    color: #1b5bbf;
  }
}
.back-button {
  border-color: #1b5bbf;
}

</style>
<style lang="less" scoped>
.el-popover {
  width: 400px;
  height: 300px;
  .el-popconfirm {
    width: 400px;
    height: 300px;
    .el-popconfirm__main {
      .el-popconfirm__action {
        button.el-button {
          //display: none;
          line-height: 1;
          white-space: nowrap;
          cursor: pointer;
          background: #fff;
          border: 1px solid #dcdfe6;
          color: #606266;
          text-align: center;
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
          margin: 0;
          -webkit-transition: 0.1s;
          transition: 0.1s;
          font-weight: 500;
          padding: 12px 20px;
          font-size: 14px;
          border-radius: 4px;

          &.el-button--primary {
            display: inline-block;
            color: #fff;
            background-color: #1b5bbf;
            border-color: #1b5bbf;
          }
        }
      }
    }
  }
}
</style>
